import * as React from 'react';
const SvgArrowDownToLine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M11.304 15.71c.39.39 1.011.39 1.402 0l3.152-3.18c.19-.2.19-.51 0-.71l-.7-.71c-.19-.2-.51-.2-.701 0l-1.461 1.48V6.5c0-.28-.22-.5-.5-.5h-.991c-.27 0-.5.22-.5.5v6.09l-1.462-1.48c-.19-.2-.51-.2-.7 0l-.701.71c-.19.2-.19.51 0 .71l3.152 3.18zM19.96 18.27a.52.52 0 0 0-.22-.22.55.55 0 0 0-.25-.05H4.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.03.06-.04.12-.05.22v.99c0 .11.02.19.05.25.05.09.12.17.22.22.05.03.11.04.18.05H19.2c.28 0 .42 0 .53-.05a.52.52 0 0 0 .22-.22c.05-.11.05-.25.05-.53v-.4c0-.28 0-.42-.05-.53z"
    />
  </svg>
);
export default SvgArrowDownToLine;
